import { render, staticRenderFns } from "./ProvisaoInformacoesAdicionais.vue?vue&type=template&id=33548eff&scoped=true"
import script from "./ProvisaoInformacoesAdicionais.vue?vue&type=script&lang=ts"
export * from "./ProvisaoInformacoesAdicionais.vue?vue&type=script&lang=ts"
import style0 from "./ProvisaoInformacoesAdicionais.vue?vue&type=style&index=0&id=33548eff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33548eff",
  null
  
)

export default component.exports